import React, { Component } from 'react'
import classNames from 'classnames'
import { Form, createFilter, Formik } from 'components/Form'
// Checkbox,
// import { FastField } from 'formik'
import { Col, Row } from 'components/Grid'
import { Button } from 'components/Buttons'
import I18n from 'locales'
import { SearchConsumer } from 'context/Search'
import {
  renderMacro,
  renderMicro,
  OPTIONS_FOR_ADS,
  OPTIONS_FOR_VALUATED,
} from './FilterBusinessTypeUtils'
import './index.css'

class FilterBusinessType extends Component {
  constructor() {
    super()
    this.state = {
      active: false,
    }
  }

  toggleContainer = () => {
    this.setState(state => ({ active: !state.active }))
  }

  componentWillMount() {
    document.addEventListener('mousedown', this.handleClick, false)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false)
  }

  handleClick = e => {
    if (this.node && this.node.contains(e.target)) {
      return
    }

    this.state.active && this.submit && this.submit()
  }

  render() {
    const { className } = this.props
    const { active } = this.state
    const classes = classNames('SearchFilter', 'FilterBusinessType', className)
    return (
      <SearchConsumer>
        {({
          onSubmit,
          filters: { businessType, privateBusiness, valuatedType },
          error,
        }) => {
          let label = ''
          if (businessType) {
            label = label.concat(businessType)
            if (valuatedType) label = label.concat(` - ${valuatedType}`)
          } else if (valuatedType) {
            label = label.concat(valuatedType)
          }

          return (
            <div style={{ position: 'relative', zIndex: 2 }}>
              <div className={classes} data-tut="step-one">
                {createFilter({
                  icon: { size: 20 },
                  error: error.businessType,
                  label: privateBusiness
                    ? `${label} Particular`
                    : label || 'Tipo de Negócio',
                  isOpen: this.state.active,
                  onClick: this.toggleContainer,
                })}
                {active && (
                  <div className="FilterContainer">
                    <Formik
                      onSubmit={onSubmit}
                      initialValues={{
                        businessType,
                        valuatedType,
                        privateBusiness,
                      }}
                    >
                      {({ values, ...props }) => {
                        this.submit = props.submitForm
                        return (
                          <Form>
                            <div
                              className="FilterBusinessType__OptionContainer"
                              ref={el => (this.node = el)}
                            >
                              {renderMacro('ads', 'Anúncios', props)}
                              {renderMicro(OPTIONS_FOR_ADS, props, values)}
                              {renderMacro('valuated', 'Avaliados', props)}
                              {renderMicro(OPTIONS_FOR_VALUATED, props, values)}
                            </div>
                            <Row between="xs">
                              <Col>
                                <Button
                                  className="FilterBusinessType__Popover__Cancel"
                                  btnStyle="link"
                                  onClick={this.toggleContainer}
                                >
                                  {I18n.t('components.actions.cancel')}
                                </Button>
                              </Col>
                              <Col>
                                <Button btnStyle="link" type="submit">
                                  {I18n.t('components.actions.ok')}
                                </Button>
                              </Col>
                            </Row>
                          </Form>
                        )
                      }}
                    </Formik>
                  </div>
                )}
              </div>
            </div>
          )
        }}
      </SearchConsumer>
    )
  }
}

export default FilterBusinessType
